import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableBillingTransactionsSummary from './tableBillingTransactionsSummary';

export default {
  title: 'Billing Transaction Monthly',
  attributeName: '',  
  fields: [
   
    {
      attributeName: 'billingtransactionsmonthly',
      label: 'Montly billing transactions',
      type: FormInputTypes.TABLECOMPONENT,
      helpText: 'Select  Room contents to be controlled by this manager',
      configFile: tableBillingTransactionsSummary,
    },
  ],
};
